import api from '@/apis/di/budgetSourceAPI.js';
import { usefilterActionCombo } from './filterActionCombo.js';
import { getCurrentInstance } from 'vue';

// Combo grid Kinh phí
export const useBudgetSourcePropertyComboMultipleGrid = (comboboxDataRemote, comboboxLoadData) => {
  const { proxy } = getCurrentInstance();
  const { extendFilter } = usefilterActionCombo();

  // func call api lấy dữ liệu combo
  const onBudgetSourcePropertyComboboxLoadData = (payload, row, column, custom) => {
    payload.sort = 'budget_source_property_code';
    payload.filter = extendFilter(payload.filter, extend);
    payload.columns += '';
    comboboxLoadData(payload, api, comboboxDataRemote, column.dataField, custom?.callBackFn);
  };

  // config columns combo
  const budgetSourcePropertyComboConfig = {
    data: comboboxDataRemote,
    columns: [
      {
        title: 'Mã nguồn',
        dataField: 'budget_source_property_code',
        width: 100,
        filterOperator: proxy.$ms.constant.FilterOperator.StartsWith,
      },
      {
        title: 'Tên nguồn',
        dataField: 'budget_source_property_name',
        filterOperator: proxy.$ms.constant.FilterOperator.Contains,
        width: 500,
      },
    ],
    displayField: 'budget_source_property_name',
    valueField: 'budget_source_property_id',
    queryMode: 'remote',
    dropdownWidth: 600,
    comboboxLoadData: onBudgetSourcePropertyComboboxLoadData,
  };

  return {
    budgetSourcePropertyComboConfig,
    onBudgetSourcePropertyComboboxLoadData, // trả về thêm để dùng chung cho cả combo ko thuộc grid
  };
};
